const getters = {
  // 用户token
  token: state => state.user.token,
  // 用户信息
  userSelf: state => state.user.userSelf,
  // 当前打开菜单list
  headerMenusList: state => state.tagsView.headerMenusList,
  // 所有数据字典
  allDictListData: state => state.publicData.allDictListData,
  //地址信息
  areaListData: state => state.address.areaListData,
  countryListData: state => state.address.countryListData,
  // 省市区所有值
  areaListDataPlus: state => state.address.areaListDataPlus,
  // 清除页面缓存
  clearPageName: state => state.tagsView.clearPageName,
  // 用户供应商类型
  userSupplier: state => state.user.userSupplier,
  // 关闭页面
  jumpAndClosePage: state => state.tagsView.jumpAndClosePage,
  // 寻样申请选择的样品
  getSampleData: state => state.addSampleToCart.sampleData,
  // 获取购物车数量
  getShoppingCartNum: state => state.addSampleToCart.shoppingCartNum,
};
export default getters;
